<div class="app" [formGroup]="empSubForm">
  <dynamic-wotc [config]="config" [formDataChanged]=formDataChanged [applyWotcclass]="applyWotcclass"
    [decideButtonclass]="decideButtonclass" [formDataChanged]="formDataChanged" #form="dynamicForm"
    (onWotcSwipe)="getPrevSwipe($event, empSubForm.value)" (submit)="submit($event, empSubForm.value)">
  </dynamic-wotc>
</div>